import loadScript from 'load-script'

var loader

export default {
  load: function () {
    if (!loader) {
      loader = new Promise(function (resolve, reject) {
        loadScript('https://cdn.ckeditor.com/4.22.1/standard/ckeditor.js', function (err) {
          if (err) reject(err)
          resolve(window.CKEDITOR)
        })
      })
    }

    return loader
  }
}



//////////////////
// WEBPACK FOOTER
// ./vendor/ckeditor/loader.js
// module id = 3zJz
// module chunks = 40